export default "__VITE_ASSET__BLyvJIJB__"